import { useQuery } from '@tanstack/react-query';
import { ShieldCheck } from 'lucide-react';
import { api } from '../api/client';

interface EeoExclusionPillProps {
  applicationId: number;
}

export function EeoExclusionPill({ applicationId }: EeoExclusionPillProps) {
  const { data } = useQuery({
    queryKey: ['eeo-exclusion-count', applicationId],
    queryFn: () => api.getEeoExclusionCount(applicationId),
  });
  const count = data?.count ?? 0;
  if (count === 0) return null;

  return (
    <span
      className="inline-flex items-center gap-1 rounded-full bg-gray-100 dark:bg-gray-800 px-2 py-0.5 text-xs text-gray-600 dark:text-gray-400"
      title="Protected-class questions (race, ethnicity, gender, disability, veteran status) are excluded from AI review by policy."
      data-testid="eeo-exclusion-pill"
    >
      <ShieldCheck className="h-3 w-3" aria-hidden="true" />
      {count} EEOC question{count === 1 ? '' : 's'} excluded by policy
    </span>
  );
}
